import UserProfileConnected from './UserProfileConnected'
export default UserProfileConnected
